// frontend/admin-portal/src/components/products/ImportSummaryPanel.jsx
import React from "react";
import { Card, Title, Alert } from "@fiberhome/shared-ui";

export default function ImportSummaryPanel({
  summary,
  dryRun = false,
  errors = [],
}) {
  if (!summary) return null;

  const items = [
    { key: "toCreate", label: "Will be created", color: "var(--fh-primary)" },
    { key: "toUpdate", label: "Will be updated", color: "var(--fh-warning)" },
    { key: "toSkip", label: "Will be skipped", color: "var(--fh-text-muted)" },
    { key: "errors", label: "Rows with errors", color: "var(--fh-danger)" },
  ];

  return (
    <Card title={dryRun ? "Preview Summary" : "Import Summary"}>
      <div className="row g-3">
        {items.map((it) => (
          <div className="col-md-3 col-sm-6" key={it.key}>
            <div className="fh-import-stat">
              <div
                className="fh-import-stat__value"
                style={{ color: it.color }}
              >
                {summary[it.key] ?? 0}
              </div>
              <div className="fh-import-stat__label">{it.label}</div>
            </div>
          </div>
        ))}
      </div>

      {!dryRun && summary.failed > 0 && (
        <Alert variant="warning" className="mt-3">
          {summary.failed} row(s) failed during commit:
          <ul className="mt-2 mb-0">
            {errors.slice(0, 10).map((e, i) => (
              <li key={i}>
                Line {e.line}: {e.message}
              </li>
            ))}
            {errors.length > 10 && <li>…and {errors.length - 10} more</li>}
          </ul>
        </Alert>
      )}
    </Card>
  );
}
